import { render, staticRenderFns } from "./languageSet.vue?vue&type=template&id=e73b2434"
import script from "./languageSet.vue?vue&type=script&lang=js"
export * from "./languageSet.vue?vue&type=script&lang=js"
import style0 from "./languageSet.vue?vue&type=style&index=0&id=e73b2434&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports